const React = require('react');


module.exports = (props) => {
  return (
    <div
      {...props}
      className={'wmin320 hmin rlv pb30 ' + (props.className || '')}
    />
  );
};
